module.exports = __webpack_public_path__ + "b4db1b5cefd5b089c46c4da279b2946e.png";